module.exports = __webpack_public_path__ + "static/media/radiobutton-01@2x.dc47af40.png";